
import state from './projectState.js'
import mutations from './projectMutations.js'
import actions from './projectAction.js'
import getters from './projectGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

